/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { STATES } from 'sarsaparilla';

export function stateNameToAbbreviation(name: string | undefined): string {
    if (!name) {
        return '';
    }

    const maybeStateItem = STATES.find((state) => {
        return state.label.toLowerCase() === name.trim().toLowerCase();
    });

    return maybeStateItem?.value ?? name;
}

export function formatLocationString(location: string): string {
    const parts = location
        .split(',')
        .filter(
            (part) =>
                !part.trim().toLowerCase().includes('united states') &&
                part.trim().toLowerCase() !== 'usa'
        );

    if (parts.length === 1) {
        return parts[0];
    }

    const city = parts[0];
    const state = stateNameToAbbreviation(parts[1]);

    return `${city}, ${state}`;
}
